import styled from "styled-components";
import { ButtonContainerBoxProps } from "./ButtonSearch.types";
import { devices } from "../../../utils/styled/_variables.styled";

export const ButtonSearchBox = styled.a<ButtonContainerBoxProps>`
  display: flex;
  width: 100%;
  cursor: pointer;
  background-color: ${(props: { $backgroundcolor: string }) =>
    props.$backgroundcolor};


  h3.modal__title{
    text-align: center !important;
  }

  .buttoncard__icon {
    height: 28px;
    width: 28px;
    @media ${devices.desktop} {
      height: 32px;
      width: 32px;
    }
  }
  .buttoncard__text {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding-bottom: 2px;
    height: 86px;
    justify-content: center;
    @media ${devices.desktop} {
      height: 88px;
    }
    @media ${devices.mobileSmall}{
      height: unset;
    }
    p {
      color: #ffffff;
      font-style: normal;
      font-weight: 700;
      line-height: 120%;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    div:nth-child(1) {
      p {
        font-size: 20px;
        @media ${devices.desktop} {
          font-weight: 700;
          font-size: 24px;
          line-height: 30px;
        }
      }
    }
    div:nth-child(2) {
      p {
        font-size: 14px;
        @media ${devices.desktop} {
          font-size: 14px;
          line-height: 24px;
        }
      }
    }
  }

`;
